import React, { useState } from "react";
import "../styles/Gallery.scss";
import { PagesBanner } from "../components";
import { motion } from "framer-motion";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = Array.from({ length: 108 }, (_, i) => ({
    id: i + 1,
    src: `/gallery/${i + 1}.jpg`,
    alt: `Gallery Image ${i + 1}`,
  }));

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (!selectedImage) return;
    const prevId =
      selectedImage.id === 1 ? images.length : selectedImage.id - 1;
    setSelectedImage(images[prevId - 1]);
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    if (!selectedImage) return;
    const nextId =
      selectedImage.id === images.length ? 1 : selectedImage.id + 1;
    setSelectedImage(images[nextId - 1]);
  };

  React.useEffect(() => {
    if (!selectedImage) return;
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") handlePrevImage(e);
      if (e.key === "ArrowRight") handleNextImage(e);
      if (e.key === "Escape") handleCloseModal();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImage]);

  return (
    <>
      <PagesBanner
        title="Our Gallery"
        description="Photos are the timeless keepers of memories, making the unforgettable last forever."
      />
      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((image) => (
            <motion.div
              key={image.id}
              className="gallery-item"
              onClick={() => handleImageClick(image)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </motion.div>
          ))}
        </div>

        {selectedImage && (
          <div className="modal" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="modal-arrow left"
                onClick={handlePrevImage}
                aria-label="Previous image"
              >
                &#x3c;
              </button>
              <img src={selectedImage.src} alt={selectedImage.alt} />
              <button
                className="modal-arrow right"
                onClick={handleNextImage}
                aria-label="Next image"
              >
                &#x3e;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;
